import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { useCompanyName } from 'Components/Common/ThemeSettings/themeutitlity';

const Footer = (props: any) => {
    const user = useSelector((state: ApplicationState) => state.auth.userProfile);
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © {useCompanyName()}.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                {/* {t.()} */}
                                {props.t("design_and_develop_by")}  {useCompanyName()}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default withTranslation()(Footer);